export default "__VITE_ASSET__Oq45v3PX__"